// DO NOT MODIFY THIS FILE
// THIS IS A SNAPSHOT OF SUPPORTED ADVANCED SEARCH TYPES AT A SPECIFIC VERSION
// IF YOU NEED TO CHANGE THE STRUCTURE OF THE TYPES, MAKE A NEW VERSION

import {
  GEOSPARQL_JSON_LITERAL_IRI,
  GEOSPARQL_WKT_LITERAL_IRI,
  XSD_BOOLEAN_IRI,
  XSD_DATE_IRI,
  XSD_DATE_TIME_IRI,
  XSD_DAY_TIME_DURATION_IRI,
  XSD_DECIMAL_IRI,
  XSD_DOUBLE_IRI,
  XSD_DURATION_IRI,
  XSD_FLOAT_IRI,
  XSD_INTEGER_IRI,
  XSD_STRING_IRI,
  XSD_TIME_IRI,
  XSD_YEAR_MONTH_DURATION_IRI,
} from 'bones/constants/iris';

export const QUERY_BUILDER_V5 = 5;

export enum ConjunctionV5 {
  AND_NOT = 'AND_NOT',
  OR = 'OR',
}

export enum DirectionV5 {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
}

export enum OperatorTypeV5 {
  OBJECT = 'OBJECT',
  DATATYPE = 'DATATYPE',
  INSTANCE = 'INSTANCE',
}

export enum InstanceOperatorTypeV5 {
  IN = 'IN',
}

export enum ObjectOperatorTypeV5 {
  CONNECTED = 'CONNECTED',
}

export enum DatatypeOperatorTypeV5 {
  EXISTS = 'EXISTS',
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  EQUALS = 'EQUALS',
  DOES_NOT_EQUAL = 'DOES_NOT_EQUAL',
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  // boolean
  IS = 'IS',
  // numeric
  GT = 'GREATER_THAN',
  LT = 'LESS_THAN',
  GTE = 'GREATER_THAN_OR_EQUAL_TO',
  LTE = 'LESS_THAN_OR_EQUAL_TO',
  // date
  ON = 'ON',
  NOT_ON = 'NOT_ON',
  AFTER = 'AFTER',
  AFTER_OR_ON = 'AFTER_OR_ON',
  BEFORE = 'BEFORE',
  BEFORE_OR_ON = 'BEFORE_OR_ON',
  BETWEEN = 'BETWEEN',
}

export const ANY_CLASS_IRI_V5 = '__ANY_CLASS__';

export const INSTANCE_IRI_V5 = '__INSTANCE__';

export const INSTANCE_SPLIT_SYMBOL_V5 = ',';

export const DATE_SPLIT_SYMBOL_V5 = '_';

export const XSD_DATATYPE_IRIS_V5 = [
  GEOSPARQL_JSON_LITERAL_IRI,
  GEOSPARQL_WKT_LITERAL_IRI,
  XSD_BOOLEAN_IRI,
  XSD_DATE_IRI,
  XSD_DATE_TIME_IRI,
  XSD_DAY_TIME_DURATION_IRI,
  XSD_DECIMAL_IRI,
  XSD_DOUBLE_IRI,
  XSD_DURATION_IRI,
  XSD_FLOAT_IRI,
  XSD_INTEGER_IRI,
  XSD_STRING_IRI,
  XSD_TIME_IRI,
  XSD_YEAR_MONTH_DURATION_IRI,
] as const;

// null for unknown
export type DatatypeRangeV5 = (typeof XSD_DATATYPE_IRIS_V5)[number] | null;

export const DEFAULT_OPERATOR_TYPE_BY_DATATYPE_RANGE_V5: {
  [key: string]: DatatypeOperatorTypeV5;
} = {
  [GEOSPARQL_JSON_LITERAL_IRI]: DatatypeOperatorTypeV5.EQUALS,
  [GEOSPARQL_WKT_LITERAL_IRI]: DatatypeOperatorTypeV5.EQUALS,
  [XSD_BOOLEAN_IRI]: DatatypeOperatorTypeV5.IS,
  [XSD_DATE_IRI]: DatatypeOperatorTypeV5.ON,
  [XSD_DATE_TIME_IRI]: DatatypeOperatorTypeV5.ON,
  [XSD_DAY_TIME_DURATION_IRI]: DatatypeOperatorTypeV5.EQUALS,
  [XSD_DECIMAL_IRI]: DatatypeOperatorTypeV5.EQUALS,
  [XSD_DOUBLE_IRI]: DatatypeOperatorTypeV5.EQUALS,
  [XSD_DURATION_IRI]: DatatypeOperatorTypeV5.EQUALS,
  [XSD_FLOAT_IRI]: DatatypeOperatorTypeV5.EQUALS,
  [XSD_INTEGER_IRI]: DatatypeOperatorTypeV5.EQUALS,
  [XSD_STRING_IRI]: DatatypeOperatorTypeV5.EQUALS,
  [XSD_TIME_IRI]: DatatypeOperatorTypeV5.ON,
  [XSD_YEAR_MONTH_DURATION_IRI]: DatatypeOperatorTypeV5.EQUALS,
};

export const OPERATOR_TYPES_BY_DATATYPE_RANGE_V5: {
  [key: string]: DatatypeOperatorTypeV5[];
} = {
  [GEOSPARQL_JSON_LITERAL_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
  ],
  [GEOSPARQL_WKT_LITERAL_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
  ],
  [XSD_BOOLEAN_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.IS,
  ],
  [XSD_DATE_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.ON,
    DatatypeOperatorTypeV5.NOT_ON,
    DatatypeOperatorTypeV5.AFTER,
    DatatypeOperatorTypeV5.AFTER_OR_ON,
    DatatypeOperatorTypeV5.BEFORE,
    DatatypeOperatorTypeV5.BEFORE_OR_ON,
    DatatypeOperatorTypeV5.BETWEEN,
  ],
  [XSD_DATE_TIME_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.ON,
    DatatypeOperatorTypeV5.NOT_ON,
    DatatypeOperatorTypeV5.AFTER,
    DatatypeOperatorTypeV5.AFTER_OR_ON,
    DatatypeOperatorTypeV5.BEFORE,
    DatatypeOperatorTypeV5.BEFORE_OR_ON,
    DatatypeOperatorTypeV5.BETWEEN,
  ],
  [XSD_DAY_TIME_DURATION_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_DECIMAL_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_DOUBLE_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_DURATION_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_FLOAT_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_INTEGER_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_STRING_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.CONTAINS,
    DatatypeOperatorTypeV5.DOES_NOT_CONTAIN,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
  ],
  [XSD_TIME_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.ON,
    DatatypeOperatorTypeV5.NOT_ON,
    DatatypeOperatorTypeV5.AFTER,
    DatatypeOperatorTypeV5.AFTER_OR_ON,
    DatatypeOperatorTypeV5.BEFORE,
    DatatypeOperatorTypeV5.BEFORE_OR_ON,
    DatatypeOperatorTypeV5.BETWEEN,
  ],
  [XSD_YEAR_MONTH_DURATION_IRI]: [
    DatatypeOperatorTypeV5.EXISTS,
    DatatypeOperatorTypeV5.DOES_NOT_EXIST,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
};

export const COMPARISON_OPERATOR_TYPES_BY_DATATYPE_RANGE_V5: {
  [key: string]: DatatypeOperatorTypeV5[];
} = {
  [GEOSPARQL_JSON_LITERAL_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
  ],
  [GEOSPARQL_WKT_LITERAL_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
  ],
  [XSD_BOOLEAN_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
  ],
  [XSD_DATE_IRI]: [
    DatatypeOperatorTypeV5.ON,
    DatatypeOperatorTypeV5.NOT_ON,
    DatatypeOperatorTypeV5.AFTER,
    DatatypeOperatorTypeV5.AFTER_OR_ON,
    DatatypeOperatorTypeV5.BEFORE,
    DatatypeOperatorTypeV5.BEFORE_OR_ON,
  ],
  [XSD_DATE_TIME_IRI]: [
    DatatypeOperatorTypeV5.ON,
    DatatypeOperatorTypeV5.NOT_ON,
    DatatypeOperatorTypeV5.AFTER,
    DatatypeOperatorTypeV5.AFTER_OR_ON,
    DatatypeOperatorTypeV5.BEFORE,
    DatatypeOperatorTypeV5.BEFORE_OR_ON,
  ],
  [XSD_DAY_TIME_DURATION_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_DECIMAL_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_DOUBLE_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_DURATION_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_FLOAT_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_INTEGER_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
  [XSD_STRING_IRI]: [
    DatatypeOperatorTypeV5.CONTAINS,
    DatatypeOperatorTypeV5.DOES_NOT_CONTAIN,
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
  ],
  [XSD_TIME_IRI]: [
    DatatypeOperatorTypeV5.ON,
    DatatypeOperatorTypeV5.NOT_ON,
    DatatypeOperatorTypeV5.AFTER,
    DatatypeOperatorTypeV5.AFTER_OR_ON,
    DatatypeOperatorTypeV5.BEFORE,
    DatatypeOperatorTypeV5.BEFORE_OR_ON,
  ],
  [XSD_YEAR_MONTH_DURATION_IRI]: [
    DatatypeOperatorTypeV5.EQUALS,
    DatatypeOperatorTypeV5.DOES_NOT_EQUAL,
    DatatypeOperatorTypeV5.GT,
    DatatypeOperatorTypeV5.GTE,
    DatatypeOperatorTypeV5.LT,
    DatatypeOperatorTypeV5.LTE,
  ],
};

export const OPERATOR_SYMBOLS_BY_DATATYPE_OPERATOR_V5 = {
  // various
  [DatatypeOperatorTypeV5.EXISTS]: 'Exists',
  [DatatypeOperatorTypeV5.DOES_NOT_EXIST]: 'Not Exists',
  [DatatypeOperatorTypeV5.EQUALS]: '=',
  [DatatypeOperatorTypeV5.DOES_NOT_EQUAL]: '!=',
  // numeric
  [DatatypeOperatorTypeV5.GT]: '>',
  [DatatypeOperatorTypeV5.LT]: '<',
  [DatatypeOperatorTypeV5.GTE]: '>=',
  [DatatypeOperatorTypeV5.LTE]: '<=',
  // date (minus between)
  [DatatypeOperatorTypeV5.ON]: '=',
  [DatatypeOperatorTypeV5.NOT_ON]: '!=',
  [DatatypeOperatorTypeV5.AFTER]: '>',
  [DatatypeOperatorTypeV5.BEFORE]: '<',
  [DatatypeOperatorTypeV5.AFTER_OR_ON]: '>=',
  [DatatypeOperatorTypeV5.BEFORE_OR_ON]: '<=',
};

export const TEXT_BY_OPERATOR_TYPE_V5 = {
  [DatatypeOperatorTypeV5.EXISTS]: 'exists',
  [DatatypeOperatorTypeV5.DOES_NOT_EXIST]: 'does not exist',
  [DatatypeOperatorTypeV5.EQUALS]: 'equal',
  [DatatypeOperatorTypeV5.DOES_NOT_EQUAL]: 'does not equal',
  [DatatypeOperatorTypeV5.CONTAINS]: 'contains',
  [DatatypeOperatorTypeV5.DOES_NOT_CONTAIN]: 'does not contain',
  [DatatypeOperatorTypeV5.IS]: 'is',
  [DatatypeOperatorTypeV5.GT]: 'greater than',
  [DatatypeOperatorTypeV5.LT]: 'less than',
  [DatatypeOperatorTypeV5.GTE]: 'greater than or equal to',
  [DatatypeOperatorTypeV5.LTE]: 'less than or equal to',
  [DatatypeOperatorTypeV5.ON]: 'on',
  [DatatypeOperatorTypeV5.NOT_ON]: 'not on',
  [DatatypeOperatorTypeV5.AFTER]: 'after',
  [DatatypeOperatorTypeV5.AFTER_OR_ON]: 'after or on',
  [DatatypeOperatorTypeV5.BEFORE]: 'before',
  [DatatypeOperatorTypeV5.BEFORE_OR_ON]: 'before or on',
  [DatatypeOperatorTypeV5.BETWEEN]: 'between',
};
